import { useState } from 'react';
import BannerToggle from '@/common/FeatureBranch/BannerToggle';
import BranchInfo from '@/common/FeatureBranch/BranchInfo';
import ClearAllButton from '@/common/FeatureBranch/ClearAllButton';
import ClearButton from '@/common/FeatureBranch/ClearButton';
import { getCollapsedStorageKey } from '~/utilities/featureBranch';
import {
  loadItemFromLocalStorage,
  saveItemToLocalStorage
} from '~/utilities/localStorage';

type OwnProps = {
  currentNativeAppCapabilities?: string;
  onOpenPassengerTools: () => void;
};

export default function FeatureBranchBanner({
  currentNativeAppCapabilities,
  onOpenPassengerTools
}: OwnProps) {
  const collapsedStorageKey = getCollapsedStorageKey();
  const [showBanner, setShowBanner] = useState(
    () => loadItemFromLocalStorage<boolean>(collapsedStorageKey) !== true
  );

  const handleToggle = () => {
    setShowBanner(previousShowBanner => {
      const nextShowBanner = !previousShowBanner;
      saveItemToLocalStorage(collapsedStorageKey, !nextShowBanner);

      return nextShowBanner;
    });
  };

  return (
    <div className="m-4 flex w-fit max-w-full items-center bg-yellow-2 p-4 opacity-90">
      <BannerToggle showBanner={showBanner} onToggle={handleToggle} />

      {showBanner ? (
        <>
          <BranchInfo
            currentNativeAppCapabilities={currentNativeAppCapabilities}
            onOpenPassengerTools={onOpenPassengerTools}
          />
          <ClearButton />
          <ClearAllButton />
        </>
      ) : null}
    </div>
  );
}
